import React from 'react';
export function GluteMechanism() {
  return <section aria-labelledby="glute-mecanismo" className="w-full bg-coal-deep text-white" data-id="element-79" data-mp="2lw963mmnhhvh">
      <div className="mx-auto w-full max-w-4xl px-5 py-16 text-center sm:px-8 sm:py-24 lg:py-32" data-id="element-80" data-mp="1caxryqw4rp6d">
        <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-81" data-mp="1798el4lfqzf4">
          El mecanismo
        </p>

        <h2 id="glute-mecanismo" className="mx-auto mt-5 max-w-3xl text-[1.9rem] font-extrabold uppercase leading-[1.02] tracking-tight sm:text-5xl" data-id="element-82" data-mp="13bswxujs2dyy">
          El Protocolo <span className="text-ember" data-id="element-83" data-mp="thtvkxrj2y82">“Unlock”</span> neuromuscular
        </h2>

        <p className="mx-auto mt-7 max-w-2xl text-[1.02rem] leading-relaxed text-white/60 sm:text-lg" data-id="element-84" data-mp="oktnkhb4bleb">
          En lugar de simplemente mover peso, usamos una secuencia de pre-activación y pausas
          isométricas de 3 segundos que obligan al sistema nervioso a enviar la señal eléctrica
          directo al glúteo.
        </p>

        <p className="mx-auto mt-8 max-w-2xl text-xl font-semibold leading-snug sm:text-2xl" data-id="element-85" data-mp="2mar8j3ic08b8">
          Al desconectar los cuádriceps, las fibras del glúteo despiertan y crecen por pura
          necesidad de supervivencia.
        </p>

        <dl className="mt-14 grid gap-10 border-t border-coal-line pt-10 text-left sm:grid-cols-3 sm:gap-8" data-id="element-86" data-mp="2dauhwwcdszdj">
          {[{
          term: '5 min',
          desc: 'de pre-activación antes de cada sesión.'
        }, {
          term: '3 seg',
          desc: 'de pausa isométrica en el punto de máxima tensión.'
        }, {
          term: '21 días',
          desc: 'de plan estructurado, sin improvisar nada.'
        }].map(item => <div key={item.term} data-id="element-87" data-mp="2vziyj63u0iji">
              <dt className="text-3xl font-extrabold tracking-tight text-ember sm:text-4xl" data-id="element-88" data-mp="2w2n5ucclfuee">
                {item.term}
              </dt>
              <dd className="mt-2 text-[0.95rem] leading-relaxed text-white/50" data-id="element-89" data-mp="1kkvuf5du5aaz">{item.desc}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}